import React from 'react';
import { Link } from 'react-router-dom';
import {
    Button,
    Form,
    Row,
    Col,
    Select,
    DatePicker, Input,
} from 'antd';
const FormItem = Form.Item;
import {formatFormData} from './utils';
import { actions, asyncGet } from './reducers';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
const spans = {
    xs: 14,
    sm: 14,
    md: 6,
    lg: 6,
    xl: 6,
};

class Search extends React.Component {
    constructor(props) {
        super(props);
    }

    handleReset= () => {
        this.props.form.resetFields();
    }

    // 查询
    handleSearch = () => {
        let values = this.props.form.getFieldsValue();
        for (let i in values) {
            if (values[i] == -1 || values[i] === '' || values[i] === undefined) {
                delete values[i];
            }
        }
        console.log('=====searchValue', values);
        this.props.changeSearchValues(formatFormData(values));
        this.props.resetPagination();
        this.props.asyncGet();
    }
    addOperationRecords = () =>{
        this.props.addShow();
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const {allMonitorName} = this.props;
        let taskMonitorList1 = new Array();
        allMonitorName.forEach(
            taskInfo =>{
                taskMonitorList1.push(taskInfo['monitoringName']);
            }
        );
        let i =0;
        const allMonitor = taskMonitorList1.map(item => {
            return (
                <Option key={i} value={item}>
                    {item}
                </Option>
            );
            i++;
        });
        const dateFormat = 'YYYY-MM-DD';
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>日常运营手册</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{ marginBottom: '10px' }}>
                        <Col span={4}>
                            <FormItem label="标题" {...spans}>
                                {getFieldDecorator('title')(
                                    <Input placeholder="请输入"/>
                                )}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem label="检测公司" {...spans}>
                                {getFieldDecorator('monitorName')(
                                    <Select allowClear placeholder="全部" style={{ width: 160 }}>
                                        <Option key='0' value='-1'>
                                            全部
                                        </Option>
                                        {allMonitor}
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem label="关联任务" {...spans}>
                                {getFieldDecorator('concactTask')(
                                    <Input placeholder="请输入"/>
                                )}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem label="异常摘要" {...spans}>
                                {getFieldDecorator('erroMark')(
                                    <Input placeholder="请输入"/>
                                )}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem label="异常标签" {...spans}>
                                {getFieldDecorator('tip')(
                                    <Input placeholder="请输入"/>
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button style={{ margin: '0 8px' }} onClick={this.handleReset}>
                                重置
                            </Button>
                            <Button type="primary" onClick={this.handleSearch} style={{ margin: '0 8px' }}>
                                搜索
                            </Button>
                            <Button type="primary" onClick={this.addOperationRecords} style={{ margin: '0 8px' }}>
                                添加
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    allMonitorName: state.operationRecords.allMonitorName,
});

const mapDispatchToProps = dispatch => ({
    changeSearchValues: values => dispatch(actions.changeSearchValues(values)),
    resetPagination: () => dispatch(actions.changePagination({ current: 1 })),
    asyncGet: () => dispatch(asyncGet()),
    editShow: () => dispatch(actions.changeUiStatus({ isSendCommend: true })),
    addShow: () =>  dispatch(actions.changeUiStatus({ isUpdateShow: true })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Search));



// WEBPACK FOOTER //
// ./pages/sign/operationRecords/search.js